module.exports = require('./Wallet');
